import Component from '@/services/Internal-Tickets/interfaces/interfaces';
import ComponentEntity from '@/services/Internal-Tickets/interfaces/interfaces';
import { CreateTicketDto } from '@/services/Internal-Tickets/interfaces/create-ticket.dto';
import PriorityEntity from '@/services/Internal-Tickets/interfaces/interfaces';
import { StatusEntity } from '@/services/Internal-Tickets/interfaces/status.entity';
import { UpdateSettingDto } from '@/services/Internal-Tickets/interfaces/setting.entity';
import UserData from '@/services/Internal-Tickets/interfaces/user.data';
import CommentEntity from '@/services/Internal-Tickets/interfaces/comment.entity';
import NoteEntity from '@/services/Internal-Tickets/note.entity';
import AssigneeEntity from '@/services/Internal-Tickets/interfaces/assignee.entity';


export default interface InternalTicketsRepositoryInterface {
  getBugs(): Promise<Ticket[]>
  getFeatures(): Promise<Ticket[]>
  getComponents(): Promise<ComponentEntity[]>
  getPriorities(): Promise<PriorityEntity[]>
  getStatuses(): Promise<StatusEntity[]>
  createTicket(dto: CreateTicketDto): Promise<Ticket>
  getTicketInfo(id: number): Promise<Ticket>
  getArchive(): Promise<[Ticket[], number]>
  createSetting(type: SettingType, data: UpdateSettingDto): Promise<void>
  updateSetting(type: SettingType,id: number, dto: UpdateSettingDto): Promise<void>
  deleteSetting(type: SettingType,id: number): Promise<void>
  createComment(ticketId: number, object: { message: string }): Promise<CommentEntity>
  createNote(ticketId: number, object: { message: string }): Promise<NoteEntity>
  getUsersData(dto: any[]): Promise<UserData[]>
  getAssignees(): Promise<AssigneeEntity[]>
  refreshAssignees(): Promise<void>
  assignTicket(ticketId: string, assigneeId: string): Promise<void>
  changeStatus(ticketId: string, statusId: number): Promise<void>
  changeComponent(ticketId: string, componentId: number): Promise<void>
  changePriority(ticketId: string, priorityId: number): Promise<void>
  getCommentsByTicketId(ticketId: string): Promise<CommentEntity[]>
}


export interface Ticket {
  id: number,
  title: string;
  description: string;
  reporter:string
  ticketType: TicketType;
  createdAt: Date
  assignee: AssigneeEntity
  priority: PriorityEntity
  status: StatusEntity,
  component?: ComponentEntity,
  comments?: CommentEntity[];
  notes?: NoteEntity[]
}


export enum TicketType {
  BUG = 'BUG',
  FEATURE = 'FEATURE'
}

export enum SettingType {
  STATUS = 'STATUS',
  PRIORITY = 'PRIORITY',
  COMPONENT = 'COMPONENT'
}


export enum Status {
  OPEN = 'OPEN',
  INPROGRESS = 'IN-PROGRESS',
  COMPLETED = 'COMPLETED'
}

export enum Priority {
  HIGH = 'HIGH',
  Medium = 'Medium',
  LOW = 'LOW'
}



